import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6db560f3&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.defietsambassadegent/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BFormSelect, BButton, BButtonGroup, BRow} from 'bootstrap-vue'
    installComponents(component, {BCol, BFormSelect, BButton, BButtonGroup, BRow})
    

export default component.exports